"use client";

import { IconCaretUpFill } from "@decibeltrade/react-icons";
import { MarketContext } from "@decibeltrade/sdk";
import { useTranslations } from "next-intl";
import { css, cva } from "styled-system/css";
import { flex } from "styled-system/patterns";

import { Clickable } from "@/components/clickable";
import { PositiveNegative } from "@/components/text/positive-negative";
import { useCurrentMarket } from "@/contexts/current-market";
import { ellipseMarketName } from "@/utils/market";

export interface WatchlistItemProps {
  marketContext: MarketContext;
}

export function WatchlistItem({ marketContext }: WatchlistItemProps) {
  const { setCurrentMarket } = useCurrentMarket();
  const t = useTranslations("watchlist");
  const isPositive = marketContext.price_change_pct_24h > 0;

  return (
    <Clickable
      onClick={() => setCurrentMarket(marketContext.market)}
      ariaLabel={t("selectMarket", { market: marketContext.market })}
      className={flex({ gap: "4", justifyContent: "start", alignItems: "center" })}
    >
      <p className={marketNameStyles}>{ellipseMarketName(marketContext.market, "-")}</p>
      <PositiveNegative
        size="sm"
        value={marketContext.price_change_pct_24h / 100}
        showSign
        formatter="percent"
      />
      <IconCaretUpFill
        className={iconStyles({
          variant: isPositive ? "positive" : "negative",
        })}
      />
    </Clickable>
  );
}

const marketNameStyles = css({
  textStyle: "body.md",
  color: "text.secondary",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
});

const iconStyles = cva({
  base: {
    h: "[14px]",
    w: "[14px]",
  },
  variants: {
    variant: {
      positive: {
        color: "icon.positive",
      },
      negative: {
        color: "icon.negative",
        transform: "rotate(180deg)",
      },
    },
  },
});
